/*
 * @Author: your name
 * @Date: 2021-04-01 10:18:41
 * @LastEditTime: 2021-06-12 14:39:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \exclusive-cloud-admin\common\index.ts
 */
import Vue from 'vue';
// import VueCookies from 'vue-cookies-ts';

// Vue.use(VueCookies);
import BackMixin from './src/assets/mixins/back.mixin';
import CommonPipe from './src/assets/filters/common.filter';
// @ts-ignore
import efly from 'efly-ui-test';

efly.install(Vue);
efly.layer.init(window);
// @ts-ignore
import BatchOperation from './src/components/batch-operation/batch-operation.vue';
// @ts-ignore
import EasyOperate from "./src/components/easy-operate/easy-operate.vue";
// @ts-ignore
import BatchHandle from './src/components/batch-handle/batch-handle.vue';
// @ts-ignore
import SelectUser from './src/components/select-user/select-user.vue';
// @ts-ignore
import CustomList from './src/components/custom-list/custom-list.vue';
// @ts-ignore
import PageHeader from './src/components/page-header/page-header.vue'
// @ts-ignore;
import TimeSearch from "./src/components/time-search/time-search.vue"
// @ts-ignore;
import TimeSearchV2 from "./src/components/time-search-v2/time-search-v2.vue"
// @ts-ignore
import SelectData from "./src/components/select-data/select-data.vue";
// @ts-ignore
import SelectTime from "./src/components/select-time/select-time.vue";
// @ts-ignore
import LoginFooter from './src/components/login-footer/login-footer.vue';
// @ts-ignore
import SlidingVerificationCode from "./src/components/sliding-verification-code/sliding-verification-code.vue";
// 自定义指令
import LayerDirective from './src/directive/layer';

// 过滤器
const filterArr: Array<any> = [
    CommonPipe,
]

// 定义 install 方法，接收 Vue 作为参数。如果使用 use 注册插件，则所有的组件都将被注册
const install: any = function (Vue: any) {
    // 判断是否可以安装
    if (install['installed']) return
    // 自定义指令
    Vue.directive('layer', LayerDirective);
    // 遍历注册全局组件
    Vue.component('PageHeader', PageHeader);
    Vue.component('BatchOperation', BatchOperation);
    Vue.component('BatchHandle', BatchHandle);
    Vue.component('EasyOperate', EasyOperate);
    Vue.component('SelectUser', SelectUser);
    Vue.component('CustomList', CustomList);
    Vue.component('TimeSearch', TimeSearch);
    Vue.component('TimeSearchV2', TimeSearchV2);
    Vue.component("SelectData", SelectData)
    Vue.component('SelectTime', SelectTime)
    Vue.component("LoginFooter", LoginFooter)
    Vue.component('SlidingVerificationCode', SlidingVerificationCode)
    Vue.mixin(BackMixin);

    /**全局过滤器 */
    filterArr.forEach(filters => {
        Object.keys(filters).forEach(funcName => {
            if (typeof filters[funcName] === 'function') {
                Vue.filter(funcName, filters[funcName]);
            }
        })
    })
}

// 判断是否是直接引入文件
if (typeof window !== 'undefined' && window['Vue']) {
    install(window['Vue'])
}

export default {
    install,
}

